













import Vue from 'vue';

interface DataType {
  returnPage: any;
}

export default Vue.extend({
  name: 'GNotFound',
  data(): DataType {
    return { returnPage: null };
  },
  methods: {
    setReturnPage() {
      const { isBuyer, isExhibitor } = this.$auth;
      if (isBuyer) {
        this.returnPage = { name: 'buyer-favorites' };
      }
      if (isExhibitor) {
        this.returnPage = { name: 'exhibitor-brand-top' };
      }
    },
  },
  mounted() {
    this.setReturnPage();
  },
});
